import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { EventSearchState } from "./types";
import { RootState } from "../types";
import { getDefaultState } from "./state";

export const state: EventSearchState = getDefaultState();

const namespaced: boolean = true;

export const eventSearch: Module<EventSearchState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
